import { SEARCH } from "../../../constants/perspectives";
import itemFactory from "./ItemFactory";
export default (_ref => {
  let {
    options,
    newFilters
  } = _ref;
  return itemFactory({
    options,
    newFilters,
    newPerspective: SEARCH
  });
});